import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PATH_PAYMENTEZ } from '../routes/paths';
import Global from '../Global';

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default function GuestGuard({ children }) {
    const { isAuthenticated, user } = useAuth();

    if (isAuthenticated) {

        const roles = (user?.rol || []); 

        console.log("GuestGuardroles",roles);



        if (roles.includes("AFFILIATE")) {
            return <Navigate to={PATH_PAYMENTEZ.root} />;
        }

        if (roles.includes("ADVISOR")) {
            return <Navigate to={PATH_PAYMENTEZ.rootAdvisor} />;
        }

        if (roles.includes("SUPERVISOR")) {
            return <Navigate to={PATH_PAYMENTEZ.rootAdvisor} />;
        }

        if (roles.includes("ADMINISTRATOR")) {
            return <Navigate to={PATH_PAYMENTEZ.rootAdvisor} />;
        }

        if (roles.includes("MONEYGUARDADMINISTRATOR") || roles.includes("MONEYGUARD")) {
            return <Navigate to={PATH_PAYMENTEZ.rootMoneyGuard} />;
        }

        if (roles.includes("FINANCIAL")) {
            return <Navigate to={PATH_PAYMENTEZ.rootFinancial} />;
        }

        if (roles.includes("TECHNICIAN") || roles.includes("TECHNICIANADMINISTRATOR")) {
            return <Navigate to={PATH_PAYMENTEZ.rootTechnician} />;
        }

        if (roles.includes("BILLINGDATA")) {
            return <Navigate to={PATH_PAYMENTEZ.rootAdvisorBilling} />;
        }


    }


    return <>{children}</>;
}
